import templateURL from './administrationTableMenu.html';

/** @ngInject */
export function administrationTableMenu() {
    return {
        restrict: 'E',
        scope: {
            parentController: '=',
            withExport: '=',
            withExecute: '=',
            icon: '='
        },
        templateUrl: templateURL
    };
}
